/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable @typescript-eslint/no-unsafe-call */
/* eslint-disable @typescript-eslint/no-unsafe-member-access */
/* eslint-disable @typescript-eslint/no-unsafe-assignment */
/* eslint-disable @typescript-eslint/no-explicit-any */
// @ts-nocheck
import { Loader, ModalConfirmation } from '@pwc/pwc-deals-ui';
import { useTranslation } from 'react-i18next';
import { UserUtilities } from '@pwc/pwc-deals-web-common';
import classnames from 'classnames';
import { isReportLivePreview } from 'common/helpers/featureFlags';
import { useGetCurrentUser } from 'common/hooks/useGetCurrentUser';
import {
  getCommentPanelOpened,
  getComments,
  getCommentsIsLoading,
  getCurrentCommentThreads,
  getEntityType,
  getHasCommentSelection,
  getOpenNewCommentThread,
  getRibbonPanelItem,
  getViewingStatus,
  resolveAllCommentsThunk,
  setCommentPanelOpened,
  setCommentPanelRendered,
  viewResolvedComments,
  viewUnresolvedComments,
} from 'features/comments/commentsSlice';
import { COMMENT_VIEWING_STATUS } from 'features/comments/constants';
import EnableForProjectState from 'features/security/EnableForProjectState';
import { useLayoutEffect, useState } from 'react';
import Helmet from 'react-helmet';
import { useDispatch, useSelector } from 'react-redux';
import PreviewPanelHeader from '../PreviewPanel/PreviewPanelHeader';
import './CommentPanel.scss';

import CommentPanelActions from './CommentPanelActions';
import CommentPanelHeader from './CommentPanelHeader';
import { RibbonButtonTypeProps } from './PanelButton';

type Props = {
  projectId: number;
};

// TODO typed EnableForProjectState
type EnableForProjectStateProps = {
  // eslint-disable-next-line react/no-unused-prop-types
  isProjectDisabled: boolean;
};

const CommentPanel = ({ projectId }: Props): JSX.Element | null => {
  const { t } = useTranslation();
  const dispatch = useDispatch();

  // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
  const { isEntitySharedWithClient } = useSelector(getComments);

  // TODO typed selectors
  const commentsIsLoading = useSelector(getCommentsIsLoading) as boolean;
  const commentPanelOpened = useSelector(getCommentPanelOpened) as boolean;
  const viewingStatus = useSelector(getViewingStatus) as
    | 'unresolved'
    | 'resolved';
  const hasCommentSelection = useSelector(getHasCommentSelection) as boolean;
  const commentThreads = useSelector(
    getCurrentCommentThreads
  ) as Array<unknown>;
  const openNewCommentThread = useSelector(getOpenNewCommentThread);
  const ribbonPanelItemType = useSelector(getRibbonPanelItem);
  const [showResolveAllModal, setShowResolveAllModal] = useState(false);

  const currentUser = useGetCurrentUser();
  // eslint-disable-next-line @typescript-eslint/no-unnecessary-type-assertion
  const entityType = useSelector(getEntityType) as string;

  const noUnsresolvedCommentsMessage = isEntitySharedWithClient
    ? "Use this panel to add comments about the project's content."
    : 'Use this panel for comments that only PwC team can see.';

  const currentUserIsPractitioner = UserUtilities.isPractitioner(
    currentUser,
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
    projectId
  );
  const clientLabel = currentUserIsPractitioner
    ? t('clientComments')
    : t('comments');
  const commentCountLabel = isEntitySharedWithClient
    ? clientLabel
    : t('pwCComments');

  const totalComments = Array.isArray(commentThreads)
    ? commentThreads.length
    : 0;
  const totalCommentsUnresolved = commentThreads.filter(
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
    (thread) => !thread.resolved
  ).length;

  const totalCommentsRendered =
    viewingStatus === COMMENT_VIEWING_STATUS.RESOLVED
      ? totalComments
      : totalCommentsUnresolved;

  const handleResolveClick = () => {
    if (viewingStatus === COMMENT_VIEWING_STATUS.UNRESOLVED) {
      dispatch(viewResolvedComments());
    } else {
      dispatch(viewUnresolvedComments());
    }
  };

  const handleResolveAllClick = () => {
    setShowResolveAllModal(true);
  };

  const handlePanelButtonClick = () => {
    if (viewingStatus !== COMMENT_VIEWING_STATUS.UNRESOLVED) {
      dispatch(viewUnresolvedComments());
    }
    dispatch(setCommentPanelOpened(!commentPanelOpened));
  };

  const showNoCommentMessage =
    totalCommentsUnresolved === 0 &&
    totalCommentsRendered === 0 &&
    openNewCommentThread === false;
  const resolveAllModalContent = (
    <>
      <h2>Mark all comments as resolved?</h2>
      <p>
        This will resolve all comments on this content page. You can re-open
        them separately.
      </p>
    </>
  );

  const closeConfig = {
    text: 'Cancel',
    onClick: () => {
      setShowResolveAllModal(false);
    },
  };

  const submitConfig = {
    text: 'Yes, resolve all',
    onClick: () => {
      dispatch(resolveAllCommentsThunk());
      setShowResolveAllModal(false);
    },
  };

  // TODO fix this
  useLayoutEffect(() => {
    dispatch(setCommentPanelRendered(true));

    return () => {
      dispatch(setCommentPanelRendered(false));
    };
  }, [dispatch]);

  const noCommentYet =
    commentPanelOpened && !commentsIsLoading && showNoCommentMessage;

  const commentClassName = classnames(
    'comment-panel-container',
    `comment-panel-${commentPanelOpened ? 'open' : 'closed'}`,
    `comment-panel-${viewingStatus}`,
    `comment-panel-${entityType === 'project' ? 'non-editable' : 'editable'}`
  );

  const isRibbonViewEnabled = ribbonPanelItemType?.type !== null;

  return (
    <>
      <ModalConfirmation
        data-testid="resolve-all-modal"
        size="xl"
        show={showResolveAllModal}
        body={resolveAllModalContent}
        closeConfig={closeConfig}
        submitConfig={submitConfig}
        title={undefined}
      />

      <EnableForProjectState projectId={projectId}>
        {({ isProjectDisabled }: EnableForProjectStateProps) => (
          <div
            className={commentClassName}
            data-testid="comment-panel-container"
          >
            <Helmet>
              <body
                data-comments={commentPanelOpened ? 'open' : 'closed'}
                {...(isRibbonViewEnabled
                  ? { 'comments-ribbon-enabled': true }
                  : {})}
              />
            </Helmet>

            <CommentPanelHeader
              commentPanelOpened={commentPanelOpened}
              commentCountLabel={commentCountLabel}
              totalCommentsRendered={totalCommentsRendered}
              hasCommentSelection={hasCommentSelection}
              handlePanelButtonClick={handlePanelButtonClick}
            />

            <CommentPanelActions
              commentPanelOpened={commentPanelOpened}
              commentCountLabel={commentCountLabel}
              totalCommentsRendered={totalCommentsRendered}
              totalComments={totalComments}
              totalCommentsUnresolved={totalCommentsUnresolved}
              hasCommentSelection={hasCommentSelection}
              isProjectDisabled={isProjectDisabled}
              handleResolveClick={handleResolveClick}
              handleResolveAllClick={handleResolveAllClick}
              viewingStatus={viewingStatus}
            />

            <Loader
              dataTestId="comment-loading-indicator"
              isVisible={commentsIsLoading && commentPanelOpened}
            />

            {noCommentYet && (
              <div
                data-testid="no-comment-message"
                className="no-comment-message"
              >
                <div className="no-comment-message__content">
                  <p>No comments yet.</p>
                  <p>{noUnsresolvedCommentsMessage}</p>
                </div>
              </div>
            )}
            <div className="top" />
            <div
              className="scrollable"
              id="comment-panel"
              data-testid="comment-panel"
              hidden={!commentPanelOpened}
            />

            <div className="bottom" />
          </div>
        )}
      </EnableForProjectState>
    </>
  );
};

export default CommentPanel;
